export { default as SearchableStrategySelect } from './SearchableStrategySelect';
